import { render, staticRenderFns } from "./DefaultMenuView.vue?vue&type=template&id=3196a77a&"
import script from "./DefaultMenuView.vue?vue&type=script&lang=js&"
export * from "./DefaultMenuView.vue?vue&type=script&lang=js&"
import style0 from "./DefaultMenuView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports